const serviceReport = (
  state : Object = { },
  action : Object
) => {
  switch (action.type) {

    case 'REPORTS_SET_SERVICE':
    {
      const newState = Object.assign({}, state);
      Object
      .keys(action.value)
      .forEach(key => {
        newState[key] = action.value[key]
      })
      return newState;
    }

    case 'REPORTS_DELETE_SERVICE':
    {
      let newState = Object.assign({}, state);
      const index = action.value.index;

      if (newState[index]){
        delete newState[index];
      }
      return newState;
    }

    default:
      return state
  }
}

export default serviceReport



// WEBPACK FOOTER //
// ./src/infra/reducers/reports/serviceReport.js